import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'AlarmService',
    controller: 'AlertInfo'
};

const methods = [
    'AddItem',
    'UpdateItem',
    'DelItem',
    'GetItemById',
    'GetAlertItemPagingList',
    'GetItemPagingList' //求助的列表请求
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const SeekHelpApi = ZJApi.defineNewApi('SeekHelpApi', factory);

export default SeekHelpApi;